//Document ready
$(function() {
	matchHeightBulk();
	//$('select').selectric();
	selectInit();
});

//Resize
$(window).resize(function() {});

//Functions

//Match height bulk
function matchHeightBulk() {}

//select init
function selectInit() {
	if($('select').length) {
		var selects = document.querySelectorAll('select');
		for (var i = 0; i < selects.length; i++) {
			new Selectr(selects[i], {
				searchable: true
			});
		}
	}
}